(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2746],{

/***/ 66508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[material]/products",
      function () {
        return __webpack_require__(72830);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={}  } = props;
    const { carousel: { carouselComponentProperties: { appliedCssClassNames: carouselClassName = ""  } = {}  } = {}  } = fullData;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>navItem.url);
        Promise.all(urls.map(_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)).then((res)=>setShortURLs(res));
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && carouselClassName === "carousel-navigation-cta-left-right") {
                setColumnClassNames((className)=>className += " breadcrumb-overlay");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CONTAINER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        if (isSsr) {
            return JSON.stringify({
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: navItem === null || navItem === void 0 ? void 0 : navItem.title,
                internalLinkPosition: "main content area",
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: navItem === null || navItem === void 0 ? void 0 : navItem.url,
                internalLinkZoneName: eventPageName + ":" + zone
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
            children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                id: "breadcrumb",
                className: "cmp-breadcrumb",
                "aria-label": "Breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: "cmp-breadcrumb__list",
                    itemScope: true,
                    itemType: ITEM_TYPE.breadcrumbList,
                    children: items.map((navItem, index)=>{
                        var ref;
                        const isLastItem = index === items.length - 1;
                        const isActive = navItem.active;
                        const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active || ((ref = items[index + 1]) === null || ref === void 0 ? void 0 : ref.current);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "cmp-breadcrumb__item".concat(navItem.active ? " cmp-breadcrumb__item--active" : ""),
                            itemProp: "itemListElement",
                            itemScope: true,
                            itemType: ITEM_TYPE.listItem,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: shortURLs[index],
                                    className: "cmp-breadcrumb__item-link",
                                    itemProp: "item",
                                    "data-zone": zone,
                                    "aria-label": navItem.title,
                                    "aria-current": navItem.active || isLastItem ? "page" : null,
                                    "data-gbh-data-layer": !isSsr && getEventInfo(navItem, index),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        itemProp: "name",
                                        dangerouslySetInnerHTML: {
                                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                        }
                                    })
                                }),
                                " ",
                                shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "cmp-breadcrumb-slash",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    itemProp: "position",
                                    content: index + 1
                                })
                            ]
                        }, "breadcrumb-item-".concat(index));
                    })
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);


/***/ }),

/***/ 72830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73661);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42053);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10884);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82660);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82706);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27514);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88751);










const AsProductList = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();
    let breadCrumb = [];
    extractBreadCrumb(data);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getAnalyticsScript */ .Szq)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getDataLayerObj */ .C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setDatalayerPageName */ .dN)(datalayerPageName));
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        extractBreadCrumb(data);
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setDatalayerPageName */ .dN)(""));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_9__/* .setGbhDataLayerCustom */ .ks)(""));
        };
    }, [
        datalayerPageName,
        gbhDataLayerCustom
    ]);
    // Recursive extractor
    function extractBreadCrumb(data) {
        if (Array.isArray(data)) {
            data.forEach((item)=>extractBreadCrumb(item, results));
        } else if (typeof data === "object" && data !== null) {
            if (data[":type"] === "kf/components/breadcrumb/v1/breadcrumb" && Array.isArray(data["items"])) {
                breadCrumb = data["items"];
                return;
            } else {
                const itemsOrder = data[":itemsOrder"];
                return itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((itemOrder, idx)=>{
                    const items = data[":items"][itemOrder];
                    if (breadCrumb.length === 0) extractBreadCrumb(items);
                    else return;
                });
            }
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript,
            breadCrumb: breadCrumb
        }),
        footer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-vh-100",
            style: {
                background: "transparent"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        data: data,
                        fullData: fullData
                    })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AsProductList);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,3574,5921,6344,4607,2634,9774,2888,179], function() { return __webpack_exec__(66508); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);